<zef-dialog
  [open]="state.open"
  [autoFocus]="'.__input'"
  [options]="dialogOptions"
  (afterOpen)="onDialogOpen()"
  (closeTrigger)="onClose$.next()">
  <div
    class="__wrap"
    (mousedown)="onPanelMousedown($event)">

    <div class="__search">
      <mat-icon class="__search-icon">search</mat-icon>
      @if (scope(); as activeScope) {
        <span class="__scope-chip">
          <mat-icon class="__scope-chip-icon" fontSet="material-icons-outlined">
            {{ activeScope.type === 'project' ? 'dashboard' : 'lan' }}
          </mat-icon>
          {{ activeScope.label }}
        </span>
      }
      <input
        #searchInputRef
        class="__input"
        type="text"
        role="combobox"
        aria-label="Search projects, services, commands"
        aria-autocomplete="list"
        aria-expanded="true"
        aria-controls="z-palette-listbox"
        [attr.aria-activedescendant]="activeIndex() > -1 ? 'z-palette-opt-' + activeIndex() : null"
        [placeholder]="scope() ? 'Jump to page…' : 'Search projects, services, commands…'"
        autocomplete="off"
        spellcheck="false"
        [value]="query()"
        (input)="onQueryChange($any($event.target).value)"
        (keydown)="onKeydown($event)"
      />
    </div>

    <zef-scrollbar class="__results" maxHeight="420px">
      <div
        id="z-palette-listbox"
        role="listbox"
        aria-label="Results"
        class="__listbox">
        @for (group of grouped(); track group.group) {
          <div class="__group">
            <h5 class="__group-title">{{ group.group }}</h5>
            @for (entry of group.entries; track entry.item.id) {
              <button
                type="button"
                role="option"
                tabindex="-1"
                class="__item"
                [id]="'z-palette-opt-' + entry.flatIndex"
                [attr.aria-selected]="entry.flatIndex === activeIndex()"
                [class.is-active]="entry.flatIndex === activeIndex()"
                (mousedown)="$event.preventDefault()"
                (click)="onRun$.next(entry.item)"
                (mousemove)="onItemPointerMove($event, entry.flatIndex)">

                <span class="__item-icon-tile">
                  <mat-icon
                    class="__item-icon"
                    fontSet="material-icons-outlined">
                    {{ entry.item.icon }}
                  </mat-icon>
                </span>

                <span class="__item-label">
                  <zef-fuse-highlight
                    [key]="'label'"
                    [matches]="entry.labelMatches"
                    [data]="entry.item"
                  />
                </span>

                @if (entry.item.sublabel) {
                  <span class="__item-sublabel">
                    <zef-fuse-highlight
                      [key]="'sublabel'"
                      [matches]="entry.sublabelMatches"
                      [data]="entry.item"
                    />
                  </span>
                }

              </button>
            }
            @if (group.moreCount > 0) {
              <div class="__more">+{{ group.moreCount }} more — type to search</div>
            }
          </div>
        } @empty {
          <div class="__empty" aria-live="polite">
            @if (idLookupPending()) {
              <zui-three-dots />
              Searching by ID…
            } @else if (query()) {
              <mat-icon class="__empty-icon" fontSet="material-icons-outlined">search_off</mat-icon>
              No results for “{{ query() }}”
            } @else {
              Loading…
            }
          </div>
        }
      </div>
    </zef-scrollbar>

    <div class="__footer">
      @if (activeIsDrillable()) {
        <span class="__footer-hint __footer-hint--drill">
          <zui-key-chip class="__footer-chip">tab</zui-key-chip>
          browse pages
        </span>
      }
      @if (scope()) {
        <span class="__footer-hint">
          <zui-key-chip class="__footer-chip">⌫</zui-key-chip>
          back
        </span>
      }
      <span class="__footer-hint">
        <zui-key-chip class="__footer-chip">↑</zui-key-chip><zui-key-chip class="__footer-chip">↓</zui-key-chip>
        navigate
      </span>
      <span class="__footer-hint">
        <zui-key-chip class="__footer-chip">↵</zui-key-chip>
        select
      </span>
      <span class="__footer-hint">
        <zui-key-chip class="__footer-chip">esc</zui-key-chip>
        close
      </span>
    </div>

  </div>
</zef-dialog>
